import React from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Supplierdetails = () => {
  const { t } = useTranslation();
  return (
    <div className="container-fluid">
      <div className="dbMain suppliersBg">
        <Leftpanel />
        <div className="dbRight">
          <Header
            link="/supplierdetailsinfo"
            breadcm=""
            title="Suppliers details"
            description=""
          />
          <div className="commonBase p-20">
            <h5 className="m-0">John Doe</h5>
            <div className="dbMaintable suppdetlTable performanceTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("Name of the supplier")}</th>
                    <th>{t("Total Orders")}</th>
                    <th>{t("Q1")}</th>
                    <th>{t("Q2")}</th>
                    <th>{t("Q3")}</th>
                    <th>{t("Q4")}</th>
                    <th>{t("Q5")}</th>
                    <th>{t("Total No")}</th>
                    <th>{t("Total Orders")}</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>
                      <Link to="/supplierdetails">John Doe</Link>
                    </td>
                    <td>20</td>
                    <td>3</td>
                    <td>0</td>
                    <td>10</td>
                    <td>8</td>
                    <td>1</td>
                    <td>22</td>
                    <td>22/20</td>
                  </tr>
                  <tr>
                    <td>
                      <Link to="/supplierdetails">John Doe</Link>
                    </td>
                    <td>20</td>
                    <td>3</td>
                    <td>0</td>
                    <td>10</td>
                    <td>8</td>
                    <td>1</td>
                    <td>22</td>
                    <td>22/20</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Supplierdetails;
